export const TECH_GROUPS = [
  {
    category: { it: "Linguaggi & Core", en: "Languages & Core" },
    items: [
      { name: "C#", level: { it: "Senior", en: "Senior" }, icon: "hash", color: "text-purple-500" },
      { name: "ASP.NET Core", level: { it: "Senior", en: "Senior" }, icon: "server", color: "text-blue-500" },
      { name: "JavaScript / TypeScript", level: { it: "Mid", en: "Mid" }, icon: "braces", color: "text-yellow-500" },
    ],
  },
  {
    category: { it: "Engine & Tools", en: "Engines & Tools" },
    items: [
      { name: "Unity", level: { it: "Senior", en: "Senior" }, icon: "box", color: "text-indigo-500" },
      { name: "PostgreSQL", level: { it: "Mid", en: "Mid" }, icon: "database", color: "text-cyan-500" },
      { name: "React", level: { it: "Mid", en: "Mid" }, icon: "atom", color: "text-sky-500" },
    ],
  },
  {
    category: { it: "Immersivo & Specializzato", en: "Immersive & Specialized" },
    items: [
      { name: "WebGL", level: { it: "Senior", en: "Senior" }, icon: "boxes", color: "text-orange-500" },
      { name: "AR/VR", level: { it: "Senior", en: "Senior" }, icon: "glasses", color: "text-emerald-500" },
      { name: "Digital Twin / DSS", level: { it: "Senior", en: "Senior" }, icon: "network", color: "text-rose-500" },
      { name: { it: "Videogiochi", en: "Video Games" }, level: { it: "Senior", en: "Senior" }, icon: "gamepad", color: "text-rose-500" },
    ],
  },
];

